import React from 'react';
import { withStyles } from '@material-ui/core/styles';

import { setClassNameInDefns } from '../definitionHelper';

import cx from 'clsx';
// import _get from 'lodash/get';
// import _set from 'lodash/set';
import _size from 'lodash/size';

const styles = theme => ({
    root: {
        width: '30px',
        height: '38px',
        background: '#F0F2F6',
        borderRadius: '3px',
    },
    foldUpperRight: {
        width: 0,
        height: 0,
        borderTop: '8px solid #FFFFFF',
        borderLeft: '8px solid transparent',
        position: 'relative',
        left: '22px',
    },
    foldBottomLeft: {
        width: 0,
        height: 0,
        borderBottom: '8px solid #CDCDCD',
        borderRight: '8px solid transparent',
        position: 'relative',
        left: '22px',
        top: '-8px',
    },
    fileTypeLabel: {
        width: '24px',
        height: '13px',
        background: '#1D8A8B',
        borderRadius: '7.96069px',
        fontSize: '9px',
        fontWeight: 900,
        color: '#FFFFFF',
        lineHeight: '13px',
        textAlign: 'center',
        position: 'relative',
        left: '11px',
        top: '2px',
    },
    ext4: {
        width: '30px',
        left: '6px',
    },
});

const getDefns = params => {
    const { props } = params;
    const { classes, label } = props;
    const { fileTypeLabel: fileTypeLabelCls, ext4: ext4Cls } = classes;

    const labelLength = _size(label);

    const defns = {
        fileTypeLabel: {
            className: cx(fileTypeLabelCls, { [ext4Cls]: labelLength === 4 }),
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const AfitdFileTypeIcon = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    // const context = useContext(LayoutContext);
    // const xxxxxx = _get(context, 'xxxxxx');
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Local states
    // const [yyyyyyyyy, setYyyyyyyyy] = useState();
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // From props
    const { label } = props;
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Defns
    const defns = getDefns({ props });
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Render
    return (
        <div {...defns.root}>
            <div {...defns.foldUpperRight} />
            <div {...defns.foldBottomLeft} />
            <div {...defns.fileTypeLabel}>{label}</div>
        </div>
    );
    //---------------------------------------------------------------------
};

export default withStyles(styles)(AfitdFileTypeIcon);
